import { useQuery } from "@tanstack/react-query"
import { useApi } from "./useApi"

const useInstruments = (query?: string) => {
  const { scientApi } = useApi()

  const { data, error, isLoading } = useQuery(
    ["trading-instruments", query],
    () => scientApi.trading.getTradingInstruments({ query: query! }),
    {
      retry: 1,
      staleTime: 60000, // 1 minute
      enabled: !!query && query.length >= 1,
    },
  )

  return {
    instruments: data,
    error,
    isLoading,
  }
}

export default useInstruments
